var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-condition" }, [
    _c(
      "div",
      { staticClass: "document-condition__wrapper" },
      [
        _c("c-input-2", {
          staticClass: "document-condition__citizenship",
          attrs: {
            "floating-label": "Гражданство",
            type: "select",
            multiple: true,
            items: _vm.citizenshipsDictionary,
            checkbox: true,
            "checkbox-value": _vm.condition.citizenshipsExcept,
            "checkbox-type": "icon",
            "checkbox-tooltip": {
              disabledText:
                "Фильтр по всем значениям в справочнике, кроме выбранных",
              activeText:
                "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
              notActiveText:
                "Включить фильтр по всем значениям в справочнике, кроме выбранных",
            },
            searchable: true,
          },
          on: { checkboxChange: _vm.onExceptChange },
          model: {
            value: _vm.condition.citizenships,
            callback: function ($$v) {
              _vm.$set(_vm.condition, "citizenships", $$v)
            },
            expression: "condition.citizenships",
          },
        }),
        _c("c-input-2", {
          staticClass: "document-condition__position",
          attrs: {
            "floating-label": "Должность",
            type: "select",
            multiple: true,
            items: _vm.positionsDictionary,
            searchable: true,
          },
          model: {
            value: _vm.condition.positions,
            callback: function ($$v) {
              _vm.$set(_vm.condition, "positions", $$v)
            },
            expression: "condition.positions",
          },
        }),
        _c("c-button-2", {
          directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
          staticClass: "document-condition__remove hidden-sm",
          attrs: {
            size: "iconic",
            title: "Удалить",
            icon: { icon: "trash", color: "secondary" },
          },
          on: {
            click: function ($event) {
              return _vm.$emit("remove")
            },
          },
        }),
        _c("c-button-2", {
          staticClass: "document-condition__remove hidden-md",
          attrs: {
            size: "small",
            label: "Удалить",
            icon: {
              icon: "trash",
              color: "secondary",
            },
          },
          on: {
            click: function ($event) {
              return _vm.$emit("remove")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }